<template>
  <div id="app">
    <!-- <multi v-show="!(path == '/' || path == '/login')"></multi> -->
    <router-view :style="!(path == '/') ? 'padding-top:60px;padding-bottom:70px' : ''" />
    <about v-show="!(path == '/' || path == '/login' || path == '/browse')"></about>
  </div>
</template>
<script>
import about from './components/footer.vue'
export default {
  components: { about },
  data() {
    return {
      path: '',
    }
  },
  mounted() {
    this.path = this.$route.path
  },
  watch: {
    $route(to, from) {
      this.path = to.path
    },
  },
}
</script>
<style lang="scss">
#app {
  font-family: 'Microsoft YaHei', 微软雅黑, 'MicrosoftJhengHei', 华文细黑,
    STHeiti, MingLiu;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  background: #2e3d4b;
  outline: 0;
}
body,
html {
  height: 100%;
}
</style>
